export default __webpack_public_path__ + "static/etno-4bb4c2ecee70e27ea8ba4704484b754e.png";